export default __webpack_public_path__ + "static/media/effPayroll.d78559cc.jpg";